import { useState } from 'react'

export function buildInviteText(handle: string, referralUrl: string): string {
  const cleanHandle = (handle || '').replace(/^@/, '').trim()
  const prefix = cleanHandle ? `Join me on Pixeloop (@${cleanHandle}).` : 'Join me on Pixeloop.'
  return `${prefix} Earn, create, and transact on-platform. Use my link: ${referralUrl}`
}

type Props = {
  referralUrl: string
  handle: string
}

export default function ShareKit({ referralUrl, handle }: Props) {
  const [copyState, setCopyState] = useState('Copy invite text')

  const inviteText = buildInviteText(handle, referralUrl)

  async function onCopyInviteText() {
    try {
      await navigator.clipboard.writeText(inviteText)
      setCopyState('Invite text copied')
      setTimeout(() => setCopyState('Copy invite text'), 1400)
    } catch {
      setCopyState('Copy failed')
      setTimeout(() => setCopyState('Copy invite text'), 1400)
    }
  }

  async function onShareInvite() {
    try {
      if ((navigator as any).share) {
        await (navigator as any).share({ title: 'Join Pixeloop', text: inviteText, url: referralUrl })
        return
      }
      await navigator.clipboard.writeText(`${inviteText}`)
      setCopyState('Invite text copied')
      setTimeout(() => setCopyState('Copy invite text'), 1400)
    } catch {
      // no-op
    }
  }

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">Share kit</h2>
      <p className="mt-1 text-sm text-white/70">Use a ready-to-send invite to improve conversion.</p>
      <div className="mt-3 rounded-xl border border-white/10 bg-black/30 p-3 text-sm text-white/80">{inviteText}</div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" onClick={onCopyInviteText} className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-black hover:brightness-110">
          {copyState}
        </button>
        <button type="button" onClick={onShareInvite} className="rounded-full border border-white/20 bg-white/5 px-4 py-2 text-sm font-semibold text-white hover:bg-white/10">
          Share invite
        </button>
      </div>
    </section>
  )
}
